const getAlertReducer = (state = { alertState:  (localStorage.getItem("cardState") ? JSON.parse(localStorage.getItem("cardState")) : "") }, action) => {
    switch (action.type) {
        case "GET_ALERT":
            return {
                alertState: action.alertState,
                
            }

        default:
            return state;
    }
}

export default getAlertReducer;


// WEBPACK FOOTER //
// ./src/reducer/getalertreducer.jsx